import React from "react";
import {FormGroup, Input, Label} from "reactstrap";

import {MFA_CODE_LENGTH} from "../../../config/MfaConfig";

const digitsOnly = (value) => (value || '')
  .replace(/[^0-9]/g, '')
  .slice(0, MFA_CODE_LENGTH);

// Controlled 6-digit TOTP entry. Strips non-digits on the way in (typing,
// paste and autofill all funnel through handleChange) and submits on Enter so
// the form's submit button is not the only route.
class ExtMfaCodeInput extends React.Component {

  handleChange = (event) => {
    this.props.onChange(digitsOnly(event.target.value));
  }

  handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      if (this.props.onSubmit) this.props.onSubmit();
    }
  }

  render() {
    return (
      <FormGroup>
        { !!this.props.label && (<Label for={this.props.id}>{this.props.label}</Label>) }
        <Input
          id={this.props.id}
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          autoComplete="one-time-code"
          maxLength={MFA_CODE_LENGTH}
          placeholder={'0'.repeat(MFA_CODE_LENGTH)}
          value={this.props.value}
          onChange={this.handleChange}
          onKeyDown={this.handleKeyDown}
          disabled={this.props.disabled}
          autoFocus={this.props.autoFocus !== false}
          style={{
            textAlign: 'center',
            fontSize: '1.5rem',
            letterSpacing: '0.4em',
            // offsets the trailing letter-space so the digits stay centred
            paddingLeft: '0.4em'
          }}
        />
        { !!this.props.hint && (
          <small className="form-text text-muted">{this.props.hint}</small>
        ) }
      </FormGroup>
    );
  }

}

export default ExtMfaCodeInput;